// Centralized API configuration
// Uses relative /api path for all requests - works in both dev and production
// The Kubernetes ingress routes /api/* to the backend service

import axios from 'axios';

// ALWAYS use relative /api path - no hardcoded hosts
export const API_URL = '/api';
export const BACKEND_URL = '';  // Empty for relative URLs

// Create axios instance with relative baseURL
export const apiClient = axios.create({
  baseURL: '/api',
  timeout: 15000,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Add request interceptor to attach auth token
apiClient.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

// Add response interceptor for error handling - NO RETRY to prevent stampede
apiClient.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.code === 'ERR_NETWORK' || error.code === 'ECONNRESET') {
      console.warn('Network error:', error.message);
    }
    return Promise.reject(error);
  }
);

export default {
  BACKEND_URL,
  API_URL,
  apiClient,
};
